<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :visible-field-form="false" :use-field-info="false" :board="this.board" :enabled="true" :is-print="isPrint" />

    <div>
      <h5 class="mb-5"><i class="dot"></i> 안전계획 수립 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>수립연도</div>
          <ml-input type="number" v-model="form.year" />
        </div>
        <div class="writeGridHalf hidden xl:block"></div>
        <div class="writeGridLineItem">
          <div>시설명</div>
          <field-selector v-model="form.fields" multiple select-all-active />
        </div>
      </div>
    </div>
    <!--    시설개요-->
    <div class="mt-28px">
      <h5 class="mb-5"><i class="dot"></i> 시설개요</h5>
      <div class="table-style">
        <table>
          <colgroup>
            <col width="80" />
          </colgroup>
          <thead style="position: sticky; top: 0; z-index: 10; box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1)">
            <tr>
              <th>연번</th>
              <th>소관부서</th>
              <th>담당자</th>
              <th>구분</th>
              <th>시설구분</th>
              <th>시설명</th>
              <th>시설위치<br />(사업장주소)</th>
              <th>관리방법</th>
              <th>면적(㎡), 형식, 연장, 차로수, 높이 등</th>
              <th>비고</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(field, index) in form.procFields" :key="`tb-${index}`">
              <td>{{ index + 1 }}</td>
              <td>{{ field.소관부서 }}</td>
              <td>{{ field.담당자 }}</td>
              <td>{{ field.구분 }}</td>
              <td>{{ field.시설구분 }}</td>
              <td>{{ field.시설명 }}</td>
              <td>{{ field.시설위치 }}</td>
              <td>{{ field.관리방법 }}</td>
              <td>{{ field.면적형식연장등 }}</td>
              <td>{{ field.비고 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module title="안전계획 파일첨부" id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly">
      <template #titleRight>
        <span style="font-weight: 400; font-size: 14px; margin-left: 8px"> <span style="color: red">[필수]</span> “관련 서식 다운로드”에서 서식을 다운로드 하여 작성 후 첨부해주세요.</span>
      </template>
    </file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import * as UiUtil from "@/util/UiUtil";

export default {
  components: {
    FieldSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        year: new Date().getFullYear().toString(),
        fields: [],
        procFields: [],
      },
      공중이용시설Codes: {
        "도서관": "library",
        "박물관 및 미술관": "museum",
        "의료기관": "medical",
        "어린이집": "daycare",
        "업무시설": "office",
        "실내공연장": "indoor-auditorium",
        "둘이상용도건축물": "mixed-use-building",
        "건축물": "building",
        "항만(방파제)": "port",
        "항만(부두)": "port-dock",
        "교량": "bridge",
        "터널": "tunnel",
        "옹벽": "retaining-wall",
        "절토사면": "cutting-slope",
        "제방": "dike",
        "소규모수도": "waterworks",
        "청사": "government-building",
        "복합시설": "complex-facility",
        "하수도": "sewage-treatment",
        "상수도": "water-supply",
        "실내체육시설": "indoor-sports-facility",
      },
      원료제조물Codes: {
        "급식소": "mass_feeding_facility",
        "먹는물": "drinking-water",
        "승강기": "lift",
        "식품제조가공업": "food-processing",
        "어린이 놀이시설": "kids-play-area",
      },
    };
  },
  watch: {
    "value": {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    "form": {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
    "form.fields": {
      immediate: true,
      deep: true,
      handler(fields) {
        console.log(fields);
        this.form.procFields = this.buildProcFields(fields);
      },
    },
  },
  computed: {
    codes() {
      const codes = {
        ...this.공중이용시설Codes,
        ...this.원료제조물Codes,
      };
      return codes;
    },
  },
  methods: {
    validate() {
      if (!this.form.fileList || this.form.fileList.length === 0) {
        UiUtil.alertDialog("안전계획 파일첨부는 필수입니다.");
        return false;
      }
      return true;
    },
    buildProcFields(fields) {
      const list = Array.isArray(fields) ? fields : [];

      return list.map((item) => {
        const meta = this.parseMeta(item.meta);
        const 종별 = (meta.facility_category && meta.facility_category.classification) || "기타";

        return {
          소관부서: meta.소관부서 || "-",
          담당자: meta.담당주무관 || "-",
          구분: this.get시설분류(meta) || "-",
          시설구분: this.get시설구분(meta, 종별) || "-",
          시설명: item.field_name || "-",
          시설위치: item.address || "-",
          관리방법: meta.관리방법 || "-",
          면적형식연장등: this.get면적형식연장등(meta) || "-",
          비고: meta.remarks || "-",
        };
      });
    },
    parseMeta(meta) {
      if (!meta) return {};
      if (typeof meta === "object") return meta;

      try {
        return JSON.parse(meta);
      } catch (e) {
        return {};
      }
    },
    getFieldTypeToString(type) {
      const keys = Object.keys(this.codes);
      for (const key of keys) {
        if (this.codes[key] === type) return key;
      }
    },
    get시설분류(data) {
      const 공중이용시설Values = Object.values(this.공중이용시설Codes);
      const 원료제조물Values = Object.values(this.원료제조물Codes);

      if (공중이용시설Values.includes(data.field_type)) {
        return "공중이용시설";
      } else if (원료제조물Values.includes(data.field_type)) {
        return "원료·제조물";
      } else {
        return "기타";
      }
    },
    get시설구분(data, 종별) {
      // 필드 타입을 시설종류(한글)로 변환
      const fieldType = data.field_type;
      const fieldTypeName = this.getFieldTypeToString(fieldType);

      // 시설종류에 따른 분기 처리
      switch (fieldTypeName) {
      case "건축물":
        return "32-건축물";

      case "교량":
        if (data && data.facility_category) {
          const classification = data.facility_category.classification || "";
          // 도로교량
          if (data.facility_category.cat2.includes("도로교량")) {
            if (classification === "1종") return "25-1종 교량";
            if (classification === "2종") return "25-2종 교량";
            if (classification === "3종") return "98-3종 교량";
            // 철도교량
          } else if (data.facility_category.cat2.includes("철도")) {
            if (classification === "1종") return "26-1종 교량";
            if (classification === "2종") return "26-2종 교량";
            if (classification === "3종") return "100-3종 교량";
          }
        }
        return "교량";

      case "도서관":
        return "7-도서관";

      case "둘이상용도건축물":
        return "17-둘이상용도건축물";

      case "박물관 및 미술관":
        return "8-박물관 및 미술관";

      case "복합시설":
        return "17-복합시설";

      case "상수도":
        return "36-상수도";

      case "수도":
      case "소규모수도":
        return "89-수도법";

      case "실내체육시설":
        return "19-실내 체육시설";

      case "실내공연장":
        return "18-실내 공연장";

      case "어린이집":
        return "11-어린이 집";

      case "업무시설":
        return "16-업무시설";

      case "옹벽":
        if (종별 === "1종") return "38-1종 옹벽";
        if (종별 === "2종") return "38-2종 옹벽";
        if (종별 === "3종") return "38-3종 옹벽";
        return "38-옹벽";

      case "의료기관":
        return "9-의료기관";

      case "절토사면":
        if (종별 === "1종") return "38-1종 절토사면";
        if (종별 === "2종") return "38-2종 절토사면";
        if (종별 === "3종") return "38-3종 절토사면";
        return "38-절토사면";

      case "제방":
        return "34-제방";

      case "청사":
        return "16-청사";

      case "터널":
        if (data && data.facility_category) {
          const classification = data.facility_category.classification || "";
          // 도로터널
          if (data.facility_category.cat2.includes("도로")) {
            if (classification === "1종") return "27-1종 터널";
            if (classification === "2종") return "27-2종 터널";
            if (classification === "3종") return "99-3종 터널";
            // 철도터널
          } else if (data.facility_category.cat2.includes("철도")) {
            if (classification === "1종") return "28-1종 터널";
            if (classification === "2종") return "28-2종 터널";
            if (classification === "3종") return "101-3종 터널";
          }
        }
        return "터널";

      case "하수도":
        return "37-하수도";

      case "항만(방파제)":
        return "29-방파제";

      case "항만(부두)":
        return "30-부두";

      case "급식소":
        return "69-식품, 식품첨가물, 기구 및 용기포장(집단급식소)";

      case "먹는물":
        return "90-먹는물 관리법";

      case "승강기":
        return "85-승강기 안전관리법";

      case "식품제조가공업":
        return "69-식품제조가공업";

      case "어린이 놀이시설":
        return "84-어린이 놀이시설 안전관리법";

      default:
        return `${fieldTypeName} - ${종별}`;
      }
    },
    get면적형식연장등(data) {
      const meta = JSON.parse(data.meta);
      const 건축_연면적 = meta.건축_연면적;
      const 층수_최고높이 = meta.층수_최고높이;
      const 연장_길이 = meta.연장_길이;

      // 교량, 터널
      const 차로수_상행 = meta.차로수_상행;
      const 차로수_하행 = meta.차로수_하행;

      // 교량
      const 경간형식 = meta.경간형식;

      // 상수도, 먹는물
      const 시설용량 = meta.시설용량;

      // 옹벽, 절토사면, 터널, 항만(부두)
      const 연장 = meta.연장;
      const 높이 = meta.높이;

      // 제방
      const 제방연장 = meta.제방연장;

      // 터널
      const 주요공법 = meta.주요공법;

      // 하수도
      const 일평균 = meta.일평균;

      // 항만(방파제)
      const 종류 = meta.종류;
      const 허용월파량_호안 = meta.허용월파량_호안;

      // 항만(부두)
      const 대표형식 = meta.대표형식;

      // 급식소
      const 일평균_식수인원 = meta.일평균_식수인원;

      const 기타_상세제원 = meta.기타_상세제원 || meta.otherSpecifications;

      let result = "";
      if (건축_연면적) result += `건축 연면적: ${건축_연면적}, `;
      if (층수_최고높이) result += `층수-최고높이: ${층수_최고높이}, `;
      if (연장_길이) result += `연장-길이: ${연장_길이}, `;
      if (차로수_상행) result += `차로수-상행: ${차로수_상행}, `;
      if (차로수_하행) result += `차로수-하행: ${차로수_하행}, `;
      if (시설용량) result += `시설용량: ${시설용량}, `;
      if (경간형식) result += `경간형식: ${경간형식}, `;
      if (연장) result += `연장: ${연장}, `;
      if (높이) result += `높이: ${높이}, `;
      if (주요공법) result += `주요공법: ${주요공법}, `;
      if (일평균) result += `일평균: ${일평균}, `;
      if (제방연장) result += `제방연장: ${제방연장}, `;
      if (종류) result += `종류: ${종류}, `;
      if (허용월파량_호안) result += `허용월파량(호안): ${허용월파량_호안}, `;
      if (대표형식) result += `대표형식: ${대표형식}, `;
      if (일평균_식수인원) result += `일평균 식수인원: ${일평균_식수인원}, `;
      if (기타_상세제원) result += `기타 상세제원: ${기타_상세제원}, `;
      result = result.slice(0, -2);

      if (result.length === 0) return "-";
      return result;
    },
  },
};
</script>

<style scoped lang="scss">
.table-style {
  height: 300px;
  background-color: #fafafa;
  overflow-y: auto;

  table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;

    th,
    td {
      border: 1px solid#cdcdcd;
      border-left: 0;
      border-right: 0;
    }

    thead {
      box-shadow: none !important;

      th {
        font-weight: 700;
        font-size: 14px;
        text-align: center;

        padding: 16px 0;
        background-color: #fafafa;
      }
    }

    td {
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      padding: 10px 0;
      background-color: white;
    }
  }
}
</style>
